const EMPTY_STUDIOS_DATA = {
  mainTitle: [
    {
      id: 1,
      text: 'Default',
      textMob: 'Default mobile',
      secondText: 'main title',
      secondTextMob: 'main title',
      isTextReverse: false,
      isTextReverseMob: false,
      isTextColumn: false,
      isTextColumnMob: true,
      isLeft: false,
      isLeftMob: true,
      isRight: false,
      isRightMob: false,
      color: '#FFFFFF',
      colorMob: '#FFFFFF',
      isTextWithLine: false,
      isTextWithLineMob: false,
      isSecondTextWithLine: false,
      isSecondTextWithLineMob: false,
      firstTextLines: [],
      secondTextLines: [],
    },
  ],
  studioBlock: [
    {
      id: 1,
      title: [
        {
          id: 1,
          text: 'First',
          textMob: 'First mobile',
          secondText: 'studio title',
          secondTextMob: 'studio title',
          isTextReverse: false,
          isTextReverseMob: false,
          isTextColumn: false,
          isTextColumnMob: true,
          isLeft: false,
          isLeftMob: true,
          isRight: false,
          isRightMob: false,
          color: '#FFFFFF',
          colorMob: '#FFFFFF',
          isTextWithLine: false,
          isTextWithLineMob: false,
          isSecondTextWithLine: false,
          isSecondTextWithLineMob: false,
          firstTextLines: [],
          secondTextLines: [],
        },
      ],
      imageSrc: '',
      imageMobileSrc: '',
      imageText: '',
      imageTextMobile: '',
      description: '',
      descriptionMobile: '',
      buttonText: '',
      buttonTextMobile: '',
      buttonLink: '',
    },
    {
      id: 2,
      title: [
        {
          id: 1,
          text: 'Second',
          textMob: 'Second mobile',
          secondText: 'studio title',
          secondTextMob: 'studio title',
          isTextReverse: false,
          isTextReverseMob: false,
          isTextColumn: false,
          isTextColumnMob: true,
          isLeft: false,
          isLeftMob: true,
          isRight: false,
          isRightMob: false,
          color: '#293241',
          colorMob: '#293241',
          isTextWithLine: false,
          isTextWithLineMob: false,
          isSecondTextWithLine: false,
          isSecondTextWithLineMob: false,
          firstTextLines: [],
          secondTextLines: [],
        },
      ],
      imageSrc: '',
      imageMobileSrc: '',
      imageText: '',
      imageTextMobile: '',
      description: '',
      descriptionMobile: '',
      buttonText: '',
      buttonTextMobile: '',
      buttonLink: '',
    },
    {
      id: 3,
      title: [
        {
          id: 1,
          text: 'Third',
          textMob: 'Third mobile',
          secondText: 'studio title',
          secondTextMob: 'studio title',
          isTextReverse: false,
          isTextReverseMob: false,
          isTextColumn: false,
          isTextColumnMob: true,
          isLeft: false,
          isLeftMob: true,
          isRight: false,
          isRightMob: false,
          color: '#FFFFFF',
          colorMob: '#FFFFFF',
          isTextWithLine: false,
          isTextWithLineMob: false,
          isSecondTextWithLine: false,
          isSecondTextWithLineMob: false,
          firstTextLines: [],
          secondTextLines: [],
        },
      ],
      imageSrc: '',
      imageMobileSrc: '',
      imageText: '',
      imageTextMobile: '',
      description: '',
      descriptionMobile: '',
      buttonText: '',
      buttonTextMobile: '',
      buttonLink: '',
    },
  ],
};

export default EMPTY_STUDIOS_DATA;
